import { BarChartData } from './../bar-chart-base/bar-chart-base.component';
import { Component, OnInit, Input, HostListener } from '@angular/core';
import { D3Event } from '../charts.model';

@Component({
  selector: 'app-bar-chart-wrapper',
  templateUrl: './bar-chart-wrapper.component.html',
  styleUrls: ['./bar-chart-wrapper.component.scss']
})
export class BarChartWrapperComponent implements OnInit {
  @Input() data: BarChartData;
  @Input() margin: any;
  @Input() showLabels = true;
  @Input() colors: { [type: string]: string };
  @Input() yDomain: [number, number];

  @Input() avgLabel: string;
  @Input() forkliftText: string;
  @Input() involvementText: string;

  xPosition = 0;
  yPosition = 0;
  showTooltip = false;
  tooltipText: {
    forklift: string;
    involvement: string;
    duration: string;
  };
  colorList: [string, string][];

  @HostListener('mousemove', ['$event'])
  onMousemove(event: MouseEvent) {
    this.xPosition = event.clientX + 10;
    this.yPosition = event.clientY - 10;
  }

  constructor() {}

  ngOnInit() {
    this.colorList = Object.entries(this.colors);
  }

  positionTooltip() {
    return {
      top: this.yPosition.toString() + 'px',
      left: this.xPosition.toString() + 'px'
    };
  }

  onMouseOver(event: D3Event) {
    const { d } = event;
    this.tooltipText = {
      forklift: d.id,
      involvement: d.percentage,
      duration: d.duration.replace(':', 'h ') + 'm'
    };
    this.showTooltip = true;
  }

  onMouseOut(event: D3Event) {
    this.showTooltip = false;
  }
}
